var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAudio = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e71296ac-fd31-454b-9450-f77ad7a1690b",
    "data-name": "Layer 2",
    viewBox: "0 0 23.48 26.92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-6ca2fb39-b700-41aa-b76c-2ca9216fd0bc {\n        fill: #009fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-e3cdc741-5645-4c77-8cfe-cc33fe09727d",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-6ca2fb39-b700-41aa-b76c-2ca9216fd0bc",
    d: "m5.95,5.06v12.32c0,.45-.4.77-.85.7-.95-.15-2,.01-3.08.64-.67.39-1.23.98-1.55,1.68-1.91,4.14,2.3,8.15,6.44,5.85,1.23-.69,1.98-2.02,1.98-3.43v-12.03c0-.46.32-.85.77-.93l9.99-1.96c.46-.09.89.26.89.73v4.81c0,.45-.4.77-.85.7-.95-.15-2,.01-3.08.64-.67.39-1.23.98-1.55,1.68-1.9,4.14,2.3,8.15,6.44,5.85,1.23-.69,1.98-2.02,1.98-3.43V2.67c0-1.68-1.53-2.94-3.18-2.61l-12.2,2.39c-1.25.25-2.15,1.34-2.15,2.61Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAudio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/audio.04cf232c.svg";
export { ForwardRef as ReactComponent };